// extracted by mini-css-extract-plugin
export var LocationSelector = "index-module--LocationSelector--507Pf";
export var go = "index-module--go--WNn8g";
export var heading = "index-module--heading--xdXuf";
export var linkhover = "index-module--linkhover--+MrnQ";
export var screenreader = "index-module--screenreader--PNC-x";
export var selectcontainer = "index-module--selectcontainer--qUjd9";
export var selectcontainererror = "index-module--selectcontainererror--LXwY9";